export default {
  phoneNumber: '電話號碼',
  emailAddress: '郵箱地址',
  empty: '未綁定',
  edit: '編輯',
  add: '添加',
}
